var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestWork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 453.918,
    y: 50.652,
    style: {
      fill: "#C9C4E1"
    },
    width: 25.811,
    height: 34.42
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#331E68"
    },
    d: "M479.73,100.132h-25.815c-8.315,0-15.059-6.742-15.059-15.059v-34.42 c0-8.317,6.743-15.059,15.059-15.059h25.815c8.315,0,15.059,6.742,15.059,15.059v34.42 C494.789,93.39,488.047,100.132,479.73,100.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#331E68"
    },
    d: "M466.824,473.267c-24.91,0-45.176-20.266-45.176-45.176V76.467c0-8.317,6.743-15.059,15.059-15.059 h60.235c8.315,0,15.059,6.742,15.059,15.059v77.446c0,8.317-6.743,15.059-15.059,15.059s-15.059-6.742-15.059-15.059V91.526 h-30.118v336.565c0,8.303,6.755,15.059,15.059,15.059c8.303,0,15.059-6.755,15.059-15.059V218.235 c0-8.317,6.743-15.059,15.059-15.059S512,209.919,512,218.235v209.855C512,453.001,491.734,473.267,466.824,473.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#331E68"
    },
    d: "M466.824,500.159c-8.315,0-15.059-6.742-15.059-15.059V458.21c0-8.317,6.743-15.059,15.059-15.059 s15.059,6.742,15.059,15.059V485.1C481.882,493.417,475.139,500.159,466.824,500.159z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 436.706,
    y: 76.467,
    style: {
      fill: "#C9C4E1"
    },
    width: 60.235,
    height: 77.448
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#331E68"
    },
    d: "M496.941,168.972h-60.235c-8.315,0-15.059-6.742-15.059-15.059V76.467 c0-8.317,6.743-15.059,15.059-15.059h60.235c8.315,0,15.059,6.742,15.059,15.059v77.446C512,162.23,505.257,168.972,496.941,168.972 z M451.765,138.854h30.118V91.526h-30.118V138.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9C4E1"
    },
    d: "M136.998,29.612v92.484c0,13.401-10.863,24.266-24.266,24.266H18.03 c-1.533,0-2.709-1.352-2.518-2.873c1.59-12.607,7.326-24.422,16.405-33.488l66.241-66.241c9.69-9.704,22.498-15.586,36.067-16.675 C135.713,26.966,136.998,28.118,136.998,29.612z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#331E68"
    },
    d: "M112.732,161.42H18.03c-5.045,0-9.853-2.17-13.19-5.954c-3.345-3.79-4.9-8.841-4.269-13.857 c2.009-15.929,9.362-30.937,20.707-42.266L87.51,33.11c12.166-12.184,28.332-19.658,45.511-21.036 c10.354-0.833,19.037,7.368,19.037,17.538v92.484C152.058,143.779,134.417,161.42,112.732,161.42z M34.81,131.302h77.922 c5.076,0,9.207-4.131,9.207-9.207v-76.63c-4.862,2.11-9.326,5.129-13.125,8.933l-66.247,66.25 C39.433,123.778,36.819,127.386,34.81,131.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#331E68"
    },
    d: "M317.137,500.159H63.127C28.32,500.159,0,471.841,0,437.033V150.691 c0-1.738,0.069-3.563,0.205-5.426c1.307-17.36,8.79-33.658,21.073-45.922L87.51,33.111c13.083-13.103,30.493-20.644,49.012-21.233 c0.038,0,0.123-0.003,0.161-0.005c0.717-0.017,1.449-0.033,2.165-0.033h178.287c34.808,0,63.127,28.318,63.127,63.127v362.064 C380.264,471.841,351.946,500.159,317.137,500.159z M138.85,41.958c-0.477,0-0.967,0.014-1.443,0.026 c-10.761,0.342-20.938,4.751-28.592,12.416l-66.248,66.248c-7.189,7.177-11.564,16.708-12.327,26.842 c-0.08,1.102-0.122,2.19-0.122,3.2v286.341c0,18.202,14.807,33.009,33.009,33.009h254.011c18.202,0,33.009-14.807,33.009-33.009 V74.969c0-18.202-14.807-33.009-33.009-33.009H138.85V41.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#331E68"
    },
    d: "M90.353,485.721c-8.315,0-15.059-6.742-15.059-15.059V210.78c0-8.317,6.743-15.059,15.059-15.059 s15.059,6.742,15.059,15.059v259.882C105.412,478.979,98.668,485.721,90.353,485.721z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestWork);
export default __webpack_public_path__ + "static/media/test-work.f4bda9aef8038ad3bf71e82e6120a95e.svg";
export { ForwardRef as ReactComponent };